import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { ILoginCallbackRequest, ILoginCallbackResponse } from "src/api/types";
import { IAppContext } from "../withAppContext";
import withAxios, { IAxiosProps } from "../withAxios";
import { getNavigationHistory } from "src/hooks/useNavigationHistory";

export default withAxios(
  class GoogleCallback extends React.Component<
    IAxiosProps & IAppContext & RouteComponentProps<any>
  > {
    public async componentDidMount() {
      const code = this.props.location.search
        .substring(1)
        .split("&")
        .filter((p) => /^code=/.test(p))
        .map((p) => decodeURIComponent(p.substring("code=".length)))[0];
      const invitationToken = localStorage.getItem("invitationToken");
      const invitationEmail = localStorage.getItem("invitationEmail");
      const data: ILoginCallbackRequest = {
        code,
        email: invitationToken && invitationEmail ? invitationEmail : undefined,
      };
      const response = (
        await this.props.axios.post<ILoginCallbackResponse>(
          "sign-in/google/callback",
          data
        )
      ).data;
      if ((response as any).status === false) {
        const invitationEmail = localStorage.getItem("invitationEmail") || response.data?.email || "";
        const message = (response as any).message || "Please choose the email address that received the invitation.";
        this.props.history.replace(
          `/pending-invite?email=${encodeURIComponent(invitationEmail)}&error=${encodeURIComponent(message)}`
        );
        return;
      }

      if (invitationToken && invitationEmail) {
        await this.props.axios.post("accept-invitation", {
          token: invitationToken,
          email: invitationEmail,
        });
        localStorage.removeItem("invitationToken");
        localStorage.removeItem("invitationEmail");
      }
      console.log("response.user---------<",response.user)
      if (response.user?.id) {
        sessionStorage.setItem(
          "is_mask_student_name",
          String(Boolean(response.user.is_mask_student_name))
        );
        this.props.removeNewUserDetails()
        this.props.userChanged(response.user);
        this.props.changeIsNewUser(false);
        try { localStorage.setItem("userId", String(response.user.id)); } catch { /* noop */ }
      } else if (response.data?.email) {
        this.props.removeNewUserDetails()
        this.props.userChanged(response.data);
        this.props.changeIsNewUser(true);
      }
      // Redirect using navigation history (same logic as login)
      const historyArr = getNavigationHistory();
      // const lastPath = historyArr[historyArr.length - 3];
      // if (lastPath?.includes("dashboard")) {
      //   console.log("Redirecting to dashboard:", lastPath);
      //   this.props.history.push(lastPath);
      // } else {
      //   console.log("Redirecting to home (no dashboard path found)");
      //   this.props.history.push("/");
      // }

      // =============================
      // const historyArr = getNavigationHistory();

// check last 2,3,4 paths
console.log("historyArr for google callback",historyArr)
const checkIndexes = [2, 3, 4]; 
let redirectPath = null;

for (const i of checkIndexes) {
  const candidate = historyArr[historyArr.length - i];
  if (candidate?.includes("dashboard")) {
    redirectPath = candidate;
    break; // stop at first match
  }
}

if (redirectPath) {
  console.log("Redirecting to dashboard:", redirectPath);
  this.props.history.push(redirectPath);
} else {
  console.log("Redirecting to home (no dashboard path found)");
  this.props.history.push("/");
}
      // =============================
      // this.props.history.push("/admin/templates");
    }

    public render() {
      return null;
    }
  }
);



// WEBPACK FOOTER //
// ./src/shared/components/login/GoogleCallback.tsx